export const sidebarTranslations = {
    ru: {
        title: "Виртуоз",
        generateVideo: "Сгенерировать видео",
        generatePoem: "Сгенерировать стихи",
        generateSong: "Сгенерировать песню",
        mergePhotos: "Объединение фото",
        animatePhoto: "Оживление фото",
        myVideos: "Мои видео",
        myPoems: "Мои стихи",
        mySongs: "Мои песни",
        myPhotos: "Мои фото",
        myGreetings: "Мои поздравления",
        generateGreetings: "Генерация поздравлений",
        myVocalRemoval: "Удаление вокала",
        vocalRemoval: "Удаление вокала",
        myPortraits: "Мои портреты",
        portraitGeneration: "Генерация портрета",
        myClips: "Мои клипы",
        clipGeneration: "Генерация клипов",
        balance: "Баланс",
        account: "Аккаунт",
        settings: "Настройки",
        socialNetworks: "Социальные сети",
        support: "Поддержка",
        faq: "Часто задаваемые вопросы",
        logout: "Выйти",
        logoutConfirmTitle: "Выйти из аккаунта?",
        logoutConfirmDescription: "Черновики создания песни и сессия будут сброшены. Продолжить?",
        help: "Помощь",
        login: "Войти",
        register: "Регистрация",
        welcome: "Добро пожаловать",
        balanceLabel: "Баланс",
        topUpBalance: "Пополнить",
        topUpAmount: "Сумма пополнения",
        topUp: "Пополнить",
        cancel: "Отмена",
        editProfile: "Редактировать профиль",
        username: "Имя пользователя",
        email: "Email",
        save: "Сохранить",
        tools: "Инструменты",
        selectPackage: "Выберите пакет",
        loadingPackages: "Загрузка пакетов...",
        buy: "Купить",
        units: "у.е.",
        create: "Создать",
        charts: "Чарты",
        invite: "Пригласить друга",
        linkAccounts: "Привязка аккаунтов",
    },
    en: {
        title: "Virtuos",
        generateVideo: "Generate Video",
        generatePoem: "Generate Poem",
        generateSong: "Generate Song",
        mergePhotos: "Merge Photos",
        animatePhoto: "Animate Photo",
        myVideos: "My Videos",
        myPoems: "My Poems",
        mySongs: "My Songs",
        myPhotos: "My Photos",
        myGreetings: "My Greetings",
        generateGreetings: "Generate Greetings",
        myVocalRemoval: "Vocal Removal",
        vocalRemoval: "Vocal Removal",
        myPortraits: "My Portraits",
        portraitGeneration: "Portrait Generation",
        myClips: "My Clips",
        clipGeneration: "Clip Generation",
        balance: "Balance",
        account: "Account",
        settings: "Settings",
        socialNetworks: "Social Networks",
        support: "Support",
        faq: "Frequently Asked Questions",
        logout: "Logout",
        logoutConfirmTitle: "Sign out?",
        logoutConfirmDescription: "Your song draft and session will be cleared. Continue?",
        help: "Help",
        login: "Login",
        register: "Register",
        welcome: "Welcome",
        balanceLabel: "Balance",
        topUpBalance: "Top up",
        topUpAmount: "Top-up amount",
        topUp: "Top up",
        cancel: "Cancel",
        editProfile: "Edit profile",
        username: "Username",
        email: "Email",
        save: "Save",
        tools: "Tools",
        selectPackage: "Select package",
        loadingPackages: "Loading packages...",
        buy: "Buy",
        units: "units",
        create: "Create",
        charts: "Charts",
        invite: "Invite a friend",
        linkAccounts: "Account linking",
    },
};
